import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import TableTwo from "../Components/Tables/TableTwo";
import { logout } from "../store/actions/authActions";

export default function UpdateGallery() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  const storedUser = localStorage.getItem("user");

  useEffect(() => {
    if (!isLoggedIn && storedUser) {
      const userData = JSON.parse(storedUser);
      dispatch({ type: "LOGIN_ADMIN", payload: userData });
    }
  }, [isLoggedIn, dispatch, storedUser]);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  if (!isLoggedIn && !storedUser) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div>
      <div
        className="px-4 content-center z-10 relative pt-44"
        style={{ backgroundColor: "#F1ECE2" }}
      >
        <div className="content-center xl:w-[1300px] m-auto">
          <div className="max-w-[1280px] w-full m-auto mt-[10px]">
            <div className="flex justify-end mb-4">
              <button
                onClick={handleLogout}
                className="px-6 py-2 bg-red-600 text-brown rounded hover:bg-red-700 transition-colors"
              >
                Logout
              </button>
            </div>
            <div className="xl:w-[600px] m-auto mb-4 mt-20">
              <p className="text-center font-GTPressura-Light text-4xl text-black px-4">
                Update Gallery
              </p>
            </div>
          </div>
          <div className="w-full overflow-x-auto md:overflow-x-hidden bg-[#F1ECE2]">
            <TableTwo />
          </div>
        </div>
      </div>
    </div>
  );
}
